import * as API from "@/services/API";
import * as API2 from "@/services/API2";
export default {
  getDefA(Id) {
    return API.apiClient.get(`/lightcharterdefa/${Id}`);
  },
  postDefA(Id, payload) {
    return API.apiClient.post(`/lightcharterdefa/${Id}`, payload);
  },
  printDefA(Id) {
    return API2.apiClient.post(`/printcharterlighta/${Id}`);
  },
  getDefB(Id) {
    return API.apiClient.get(`/lightcharterdefb/${Id}`);
  },
  postDefB(Id, payload) {
    return API.apiClient.post(`/lightcharterdefb/${Id}`, payload);
  },
  printDefB(Id) {
    return API2.apiClient.post(`/printcharterlightb/${Id}`);
  },
  getDefC(Id) {
    return API.apiClient.get(`/lightcharterdefc/${Id}`);
  },
  postDefC(Id, payload) {
    return API.apiClient.post(`/lightcharterdefc/${Id}`, payload);
  },
  printDefC(Id) {
    return API2.apiClient.post(`/printcharterlightc/${Id}`);
  },
  getDefD(Id) {
    return API.apiClient.get(`/lightcharterdefd/${Id}`);
  },
  postDefD(Id, payload) {
    return API.apiClient.post(`/lightcharterdefd/${Id}`, payload);
  },
  printDefD(Id) {
    return API2.apiClient.post(`/printcharterlightd/${Id}`);
  },

  getDefE(Id) {
    return API.apiClient.get(`/lightcharterdefe/${Id}`);
  },
  postDefE(Id, payload) {
    return API.apiClient.post(`/lightcharterdefe/${Id}`, payload);
  },
  printDefE(Id) {
    return API2.apiClient.post(`/printcharterlighte/${Id}`);
  },
  getDefF(Id) {
    return API.apiClient.get(`/lightcharterdeff/${Id}`);
  },
  postDefF(Id, payload) {
    return API.apiClient.post(`/lightcharterdeff/${Id}`, payload);
  },
  printDefF(Id) {
    return API2.apiClient.post(`/printcharterlightf/${Id}`);
  },
};
